/**
 * 贝盈 916 / 8815 机芯音乐律动（有线 `setGifLight`；无线不支持）。
 */
import { resolveEquipmentWorkMode } from "../musicRhythm/hfdWirelessMusicRhythm";
import { isBeiyingMechaM80OrM71Device } from "./beiyingMechaM80M71";
import { isBeiyingDevice8815X98Keyboard } from "./beiyingX981K";
import { SDK_KEYBOARD_MOUSE_TYPE } from "./supportedDevicesConstants";

const BEIYING_24G_RECEIVER_PRODUCT_ID = 0xfa09;

export type Beiying9168815EquipmentLike = {
  solutionRovider?: string;
  machineBoard?: string;
  vendorId?: number;
  productId?: number;
  keyboardType?: string;
  sdkType?: number | string;
  beiyingSdkFlavor?: string;
  beiying_sdk_flavor?: string;
  is4G?: boolean;
  workMode?: string | number;
  work_mode?: string | number;
};

function is24GWorkMode(workMode: string | number | undefined): boolean {
  return String(workMode) === "2" || workMode === 2;
}

/** 是否为贝盈 916 机芯（Device916 / DeviceWireLess916），不含 8815 */
export function isBeiying916Device(
  eq: Beiying9168815EquipmentLike | null | undefined
): boolean {
  if (!eq || String(eq.solutionRovider ?? "") !== "beiying") return false;
  if (isBeiyingDevice8815X98Keyboard(eq)) return false;

  if (String(eq.machineBoard ?? "") === "916") return true;
  if (isBeiyingMechaM80OrM71Device(eq)) return true;

  const flavor = String(
    eq.beiyingSdkFlavor ?? eq.beiying_sdk_flavor ?? ""
  ).trim();
  if (flavor === "916") return true;

  if (Number(eq.sdkType) === SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine) {
    return true;
  }

  return false;
}

/** 是否为贝盈 916（Device916 / DeviceWireLess916）或 8815（Device8815）机芯设备 */
export function isBeiying916Or8815Device(
  eq: Beiying9168815EquipmentLike | null | undefined
): boolean {
  if (!eq || String(eq.solutionRovider ?? "") !== "beiying") return false;

  if (isBeiying916Device(eq)) return true;
  if (isBeiyingDevice8815X98Keyboard(eq)) return true;

  const flavor = String(
    eq.beiyingSdkFlavor ?? eq.beiying_sdk_flavor ?? ""
  ).trim();
  if (flavor === "8815") return true;

  return false;
}

/** 916 / 8815 是否为有线连接（仅有线可走 setGifLight 音乐律动） */
export function isBeiying9168815WiredConnection(
  eq: Beiying9168815EquipmentLike | null | undefined
): boolean {
  if (!eq || !isBeiying916Or8815Device(eq)) return false;
  if (eq.is4G === true) return false;

  const pid = Number(eq.productId);
  if (Number.isFinite(pid) && pid === BEIYING_24G_RECEIVER_PRODUCT_ID) {
    return false;
  }

  const workMode = resolveEquipmentWorkMode(eq);
  if (is24GWorkMode(workMode)) return false;

  const pn = String((eq as { productName?: unknown }).productName ?? "")
    .trim()
    .toLowerCase();
  if (/wireless receiver|2\.4g/.test(pn)) return false;

  return true;
}

/** 子应用 / 全局律动：916 / 8815 有线且支持 setGifLight */
export function supportsBeiying9168815MusicRhythm(
  eq: Beiying9168815EquipmentLike | null | undefined
): boolean {
  return isBeiying9168815WiredConnection(eq);
}
